import ImgBanner from "@/assets/image/video-bg.png";
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png";
import OurImg from "@/assets/industry-co-led/banner/our-offering.png";
import MsuAdvantagesImg from "@/assets/industry-co-led/banner/MSU-advantages.png";
import addintionImg from '@/assets/industry-co-led/image/little-girl-checking-up-her-sight-ophthalmology-center.png';


import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Img1 from "@/assets/industry-co-led/image/infrastructure-1.png";
import Img2 from "@/assets/industry-co-led/image/infrastructure-2.png";

const Img3 = "https://cdn.msu.edu.in/seminar_hall_c0679f338f.webp";
const Img4 = "https://cdn.msu.edu.in/co_learing_space_66a6494608.webp";
const Img5 = "https://cdn.msu.edu.in/classroommain_b39d235f4d.webp";


import OJLImg1 from "@/assets/industry-co-led/image/OJL-1.png";
import OJLImg2 from "@/assets/industry-co-led/image/OJL-2.png";
import OJLImg3 from "@/assets/industry-co-led/image/OJL-3.png";
import OJLImg4 from "@/assets/industry-co-led/image/OJL-4.png";
import OJLImg5 from "@/assets/industry-co-led/image/OJL-5.png";
import OJLImg6 from "@/assets/industry-co-led/image/OJL-6.png";

export const MbaData = {
    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led PG Programmes", url: "/industry-co-led-pg-programmes" },
            { name: "MBA in Healthcare Management", url: "" },
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "MBA in Healthcare Management",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: REDVERSITY
        },
        duration: "2 Years Postgraduate Programme",
        description:
            "Learn about Health Systems and Healthcare Delivery, Healthcare Operations Management, Hospital Planning and Infrastructure Management and more.",

        stats: [
            {
                value: "Up to 70%",      // UPDATED: was "70%"
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-Job Learning (OJL)"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        buttons: {
            // download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: "https://cdn.msu.edu.in/industry-co-led-images/banner-image.webp",
            thumbnailLocal: ImgBanner,
            buttonText: "Watch Programme Video",
            url: "#"

        },

        awards: [
            "Ranked 4th among Top Skill Universities in India by Outlook",
            "Emerging University of the Year by Financial Express",
            "Best University in India for Industry Interface by CEGR"
        ]
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "MBA in Healthcare Management",   // UPDATED

        description: [
            "The MBA in Healthcare Management prepares professionals to take on leadership and strategic roles within the healthcare industry. The programme builds on advanced management principles combined with in-depth healthcare expertise, covering areas such as hospital administration, healthcare policy, financial management, operations strategy and data-driven decision-making.",

            "Students gain practical exposure through industry collaborations, case studies, internships, and live projects within real healthcare environments. With a strong focus on leadership, innovation, and system-level thinking, learners develop the ability to manage complex healthcare organisations, drive operational efficiency, and improve patient outcomes at scale."
        ],

        stats: [
            {
                value: "Up to 70%",      // UPDATED: was "70%"
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-Job Learning (OJL)"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 2-Year Journey",

        journey: [
            {
                phase: "YEAR 1",
                title: "Foundations in Management and Analytics",
                description:
                    "Organisational Behaviour, Financial Reporting, Business Statistics and more"
            },
            {
                phase: "YEAR 2",
                title: "Advanced Healthcare Management",
                description:
                    "Strategic Management, Quality Management, Medical-Legal Systems and more"
            },
            {
                phase: "FINAL PHASE (OJL)",
                title: "On-the-Job Learning & Industry Immersion",
                description:
                    "Gain experience through healthcare management training across administrative settings"
            },
            {
                phase: "GRADUATE",
                title: "MBA in Healthcare Management",
                description:
                    "Industry-ready healthcare management professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Healthcare Management Education"
        },

        description:
            "We offer a UGC-approved, 2-year postgraduate programme, MBA in Healthcare Management. It is an industry-aligned degree designed to develop advanced managerial, strategic, and leadership skills required to manage complex healthcare systems and organisations.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Organisational Behaviour and Managing People",
                "Financial Management in Healthcare",
                "Healthcare Operations Management",
                "Strategic Management of Healthcare Organisations",
                "Quality Management in Healthcare",
                "Medical-Legal System and Healthcare Compliance"
            ]
        },

        image: 'https://cdn.msu.edu.in/Mock_Interviews_and_Aptitude_Skills_Event_for_BBA_students_10_11zon_9a0fc1b52f.jpg',
    },

    whyEMT: {
        tag: "WHY HEALTHCARE MANAGEMENT. WHY NOW.",
        title: "Contribute to a system that directly impacts lives",
        description:
            "Our MBA in Healthcare Management aligns with industry trends, offering a comprehensive curriculum that balances theoretical knowledge with practical experience.",

        stats: [
            {
                value: "7.5%",
                text: "Contribution to GDP from healthcare and projected to reach $370+ billion by 2030",
            },
            {
                value: "2.7 million",
                text: "Additional jobs expected to be generated by 2027 from the healthcare industry",
            },
            {
                value: "70,000+",
                text: "Hospitals across India and increasing healthcare infrastructure investments, the demand for healthcare management professionals continues to rise",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Redversity, Delivered at MSU Campus",     // UPDATED
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only University in Sikkim aligned with paid On-the-Job-Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only University in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",       // UPDATED: was "70% practical based curriculum"
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned healthcare management professionals",    // UPDATED
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
        ],

        image: 'https://cdn.msu.edu.in/industry_learning_HA_2_1a43415474.jpg',
    },

    CTA: {
        title: "Start Your Journey in Healthcare Management with Redversity's",
        highlights: " MBA in Healthcare Management",
        url: "https://application.msu.edu.in/campus-programme-registration",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "Hands-On Experience",
        title: "On-The-Job Learning",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            {
                "id": 1,
                "src": "https://cdn.msu.edu.in/medium_Kabita_b5ccaaab65.webp",
                "srcLocal": OJLImg1,
                "alt": "Kabita Karki for On-the-Job Learning at Prashanti Diagnostic, Signtam",
                "caption": "Kabita Karki for On-the-Job Learning at Prashanti Diagnostic, Signtam"
            },
            {
                "id": 2,
                "src": "https://cdn.msu.edu.in/medium_MAMTA_35769bc27b.webp",
                "srcLocal": OJLImg2,
                "alt": "Mamta Khati for On-the-Job Learning at STNM, Gangtok",
                "caption": "Mamta Khati for On-the-Job Learning at STNM, Gangtok"
            },
            {
                "id": 3,
                "src": "https://cdn.msu.edu.in/medium_Subba_85c9905aca.webp",
                "srcLocal": OJLImg3,
                "alt": "Sancha rani Subba for On-the-Job Learning at Anukul Diagnostic, Namchi",
                "caption": "Sancha rani Subba for On-the-Job Learning at Anukul Diagnostic, Namchi"
            },
            {
                "id": 4,
                "src": "https://cdn.msu.edu.in/medium_Lalita_169d2968af.webp",
                "srcLocal": OJLImg4,
                "alt": "Lalita Pradhan for On-the-Job Learning at STNM, Gangtok",
                "caption": "Lalita Pradhan for On-the-Job Learning at STNM, Gangtok"
            },
            {
                "id": 5,
                "src": "https://cdn.msu.edu.in/medium_deepansa_9caf57d963.webp",
                "srcLocal": OJLImg5,
                "alt": "Deepansa for On-the-Job Learning at Magnus Hospital, Siliguri",
                "caption": "Deepansa for On-the-Job Learning at Magnus Hospital, Siliguri"
            },
            {
                "id": 6,
                "src": "https://cdn.msu.edu.in/medium_Bishnu_d768147532.webp",
                "srcLocal": OJLImg6,
                "alt": "Bishnu Maya Gurung for On-the-Job Learning at Siliguri Hospital",
                "caption": "Bishnu Maya Gurung for On-the-Job Learning at Siliguri Hospital"
            }
        ]
    },

    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "Bonus Credentials",
                "title": "Additional Skills Certifications",
                "description": "At Medhavi Skills University, students pursuing MBA in Healthcare Management gain opportunities for industry-recognised Skill Certifications from NISM, Great Learning Academy, Simplilearn, HubSpot Academy, Alison Academy, Keka Academy, FinX, LinkedIn Learning, Coursera and more. These certifications, earned alongside the healthcare management degree, enhance industry relevance and prepare students for both employment and entrepreneurship.",
                "image": {
                    "url": "https://cdn.msu.edu.in/industry-co-led-images/Screenshot+2026-04-30+222845.png",
                    "urlLocal": addintionImg,
                    "alternativeText": "Additional skills certifications image"
                },
                "items": [
                    {
                        "id": 1,
                        "text": "Industry-Recognised Certifications",
                        "icon": Icon1
                    },
                    {
                        "id": 2,
                        "text": "Nationally & Globally Recognised",
                        "icon": Icon2
                    }
                ],
                "button": {
                    "text": "Apply Now",
                    "link": "https://application.msu.edu.in/campus-programme-registration"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            {
                id: 1,
                src: Img1,
                srcLocal: Img1,
                size: "large",
                alt: "Pathology Lab",
                caption: "Pathology Lab"
            },
            {
                id: 2,
                src: Img2,
                srcLocal: Img2,
                size: "large",
                alt: "Microbiology Lab",
                caption: "Microbiology Lab"
            },
            {
                id: 3,
                src: Img3,
                srcLocal: Img3,
                size: "small",
                alt: "Biotechnology Lab",
                caption: "Biotechnology Lab"
            },
            {
                id: 4,
                src: Img4,
                srcLocal: Img4,
                size: "small",
                alt: "Classrooms",
                caption: "Classrooms"
            },
            {
                id: 5,
                src: Img5,
                srcLocal: Img5,
                size: "small",
                alt: "Experience a Virtual Campus Tour",
                caption: "Experience a Virtual Campus Tour",
                videoId: "lTWke3-IGz4"
            },
        ],
    },

    medhaviBuzz: {
        tag: "MEDHAVI BUZZ",
        title: "Medhavi Buzz",
        images: [
            {
                id: 1,
                src: "https://cdn.msu.edu.in/medium_Health_camp_at_Jalipool_Old_Age_Home_Gangtok_East_Sikkim_1773a36ae9.jpg",
                alt: "Health camp at Jalipool Old Age Home, Gangtok, East Sikkim",
                caption: "Health camp at Jalipool Old Age Home, Gangtok, East Sikkim"
            },
            {
                id: 2,
                src: "https://cdn.msu.edu.in/medium_Health_Camp_at_Primary_School_Rangpo_Division_e856f12b40.jpg",
                alt: "Health Camp at Primary School, Rangpo Division",
                caption: "Health Camp at Primary School, Rangpo Division"
            },
            {
                id: 3,
                src: "https://cdn.msu.edu.in/medium_Promoting_Health_and_Hygiene_among_the_Sirwani_Community_5c0cef1a74.jpg",
                alt: "Promoting Health & Hygiene among the Sirwani Community",
                caption: "Promoting Health & Hygiene among the Sirwani Community"
            },
            {
                id: 4,
                src: "https://cdn.msu.edu.in/medium_First_ID_and_CPR_hands_on_training_at_Mangzing_Secondary_School_9d4e6c3e4d.jpg",
                alt: "First Aid and CPR hands-on training at Mangzing Secondary School",
                caption: "First Aid and CPR hands-on training at Mangzing Secondary School"
            },
            {
                id: 5,
                src: "https://cdn.msu.edu.in/medium_BLS_and_Posture_Awareness_at_Kumari_Pema_57b51270b6.jpg",
                alt: "Workshops on Basic Life Support (BLS) and Posture Awareness at Kumari Pema",
                caption: "Workshops on Basic Life Support (BLS) and Posture Awareness at Kumari Pema"
            }
        ]
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",    // UPDATED
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Eligibility",
        description:
            "Bachelor's degree in any discipline from a recognised university",
        button: {
            text: 'Apply Now',
            url: ""
        },
        items: [
            {
                title: "Bachelor's Degree in Any Discipline",
                text: "Candidates with a bachelor's degree in any discipline can apply. While healthcare or life sciences backgrounds are helpful, they are not mandatory.",
            },
        ],
    },

    industryPartners: {
        tag: "INDUSTRY PARTNERS",
        title: "Our Industry Partners",
        description: "We collaborate with leading organisations across sectors to support practical learning, industry exposure, and career readiness for our students",
        partners: [
            {
                id: 1,
                src: "https://cdn.msu.edu.in/critical_care_hospital_08e305dc71.jpg",
                alt: "Critical Care Hospital"
            },
            {
                id: 2,
                src: "https://cdn.msu.edu.in/Medicity_Guwahati_8430e2f631.png",
                alt: "Medicity Guwahati"
            },
            {
                id: 3,
                src: "https://cdn.msu.edu.in/SGLH_4ae8656988.png",
                alt: "SGLH"
            },
            {
                id: 4,
                src: "https://cdn.msu.edu.in/Nephroplus_LOGO_8ec7ba2add.png",
                alt: "Nephroplus"
            },
            {
                id: 5,
                src: "https://cdn.msu.edu.in/small_pratiksha_hospital_Guwahati_logo_cdb1cd5a48.png",
                alt: "Pratiksha Hospital Guwahati"
            },
            {
                id: 6,
                src: "https://cdn.msu.edu.in/small_Apollo_Hospitals_Logo_svg_f94431f4a8.png",
                alt: "Apollo Hospitals"
            },
            {
                id: 7,
                src: "https://cdn.msu.edu.in/small_Siliguri_District_Hospital_Logo_7ef973e68b.png",
                alt: "Siliguri District Hospital"
            },
            {
                id: 8,
                src: "https://cdn.msu.edu.in/small_mukherjee_hospital_05f6e8e76e.png",
                alt: "Mukherjee Hospital"
            }
        ]
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "Join this MBA in Healthcare Management programme and step into leadership roles within the healthcare management industry",
        "roles": [
            "Healthcare Manager / Hospital Administrator",
            "Healthcare Operations Manager",
            "Healthcare Consultant",
            "Health Policy Analyst",
            "Quality & Accreditation Manager",
            "Healthcare Strategy Manager",
            "Hospital Planning & Infrastructure Manager",
            "Healthcare IT & Systems Manager",
            "Public Health Administrator",
            "Health Insurance & Claims Manager",
            "Healthcare Business Development Manager",
            "Clinical Operations Manager",
            "Healthcare Project Manager",
            "Entrepreneur in Healthcare / HealthTech"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness, and broad career opportunities across disciplines.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building the Foundation",
                "description": "This semester introduces students to core management principles, communication, and healthcare systems. Learners develop an understanding of organisational behaviour, financial reporting, and health systems while building strong analytical and professional communication skills. The focus is on creating a solid academic base and developing clarity in thinking and decision-making.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Organisational Behaviour and Managing People",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Managerial Economics",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Management Accounting",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Healthcare Business Environment (Bridging Course)",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Health Systems and Healthcare Delivery",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "Business Communication and Professional Writing",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "HDSIM-PG 1: Personality Development, Curricular Activities, Hospital Visits, Live Project I",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    }
                ],
                "learningOutcomes": [
                    "Understand core management and organisational behaviour principles",
                    "Analyse financial reports and apply managerial economics",
                    "Interpret business statistics for decision-making",
                    "Understand health systems and delivery mechanisms",
                    "Communicate professionally in business contexts"
                ]
            },
            {
                "name": "Semester 2",
                "title": "Strengthening Management & Healthcare Analytics",
                "description": "Students deepen their knowledge of finance, marketing, and healthcare operations. With subjects like financial management, healthcare operations, and biostatistics, the semester focuses on developing analytical, problem-solving, and data-driven decision-making skills essential for managing healthcare organisations.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Business Statistics and Research Methods",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Marketing Management",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Financial Management in Healthcare",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Healthcare Operations Management",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Biostatistics and Epidemiology",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "Healthcare Information Technology",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "HDSIM-PG 2: CV Building, Ambulance Ride-along, Industry Visits, Live Project II",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Elective 1: Health Insurance & Patient Management / Medical Tourism",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    }
                ],
                "learningOutcomes": [
                    "Manage healthcare finances and cost control",
                    "Apply marketing and accounting principles",
                    "Optimise healthcare operations",
                    "Use biostatistics and epidemiology in health decisions",
                    "Leverage IT for healthcare management"
                ]
            },
            {
                "name": "Semester 3",
                "title": "Strategic Thinking & Healthcare Systems Management",
                "description": "This semester focuses on advanced management concepts within healthcare. Students learn strategic management, hospital planning, quality management, and healthcare IT systems, gaining the ability to manage complex healthcare environments and improve organisational efficiency.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Strategic Management of Healthcare Organisations",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Hospital Planning and Infrastructure Management",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "Financial Reporting and Analysis",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Quality Management in Healthcare",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Medical-Legal System and Healthcare Compliance",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Healthcare Human Resource Management",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },

                    {
                        "name": "Elective 2: Disaster & Epidemic Management / Entrepreneurship in Healthcare",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "HDSIM-PG 3: Leadership, Industry Visits, Live Project III",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    }
                ],
                "learningOutcomes": [
                    "Develop and implement healthcare strategies",
                    "Plan hospital infrastructure and facilities",
                    "Manage healthcare IT systems effectively",
                    "Drive quality and accreditation processes",
                    "Navigate medical-legal and compliance frameworks"
                ]
            },
            {
                "name": "Semester 4",
                "title": "Industry Immersion & Leadership Application",
                "description": "The final semester emphasises real-world application through internships, electives, and a capstone project. Students gain hands-on experience in healthcare settings, apply strategic knowledge, and develop leadership skills required to manage healthcare organisations effectively.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Healthcare Management Internship (at Red.Health Network)",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Capstone Project and Dissertation",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "HDSIM-PG 4: Career Launch, CV Intensive, Live Project Capstone",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    }
                ],
                "learningOutcomes": [
                    "Apply strategic learning in real healthcare environments",
                    "Complete an industry internship at Red.Health Network",
                    "Execute a capstone project and dissertation",
                    "Develop leadership and operational management skills",
                    "Specialise through electives in insurance, tourism, or entrepreneurship"
                ]
            },
            {
                "name": "Value Addition",
                "title": "Value-Added Learning Opportunities",
                "description": "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",

                "subjects": [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 102,
        title: "MBA in Healthcare Management",
        FAQ: [
            {
                "id": 1,
                "Question": "What is the duration of the MBA in Healthcare Management programme?",
                "Answer": "The programme is a 2-year postgraduate course divided into 4 semesters, combining advanced management concepts with specialized healthcare knowledge."
            },
            {
                "id": 2,
                "Question": "What career opportunities are available after this programme?",
                "Answer": "Graduates can take up roles such as Healthcare Manager, Hospital Administrator, Healthcare Consultant, Strategy Manager, and Health Policy Analyst across hospitals, consulting firms, insurance, and healthcare startups."
            },
            {
                "id": 3,
                "Question": "What is the role of Redversity in this programme?",
                "Answer": "Redversity ensures industry-integrated learning by providing access to real healthcare environments, expert-led sessions, internships, and live projects. This exposure helps students gain practical experience and become job-ready for leadership roles in healthcare."
            },
            {
                "id": 4,
                "Question": "Does the programme include internships or practical exposure?",
                "Answer": "Yes, the programme includes industry internships, live projects, and a capstone dissertation, ensuring hands-on experience in real healthcare environments."
            },
            {
                "id": 5,
                "Question": "Who is eligible to apply for this programme?",
                "Answer": "Candidates with a bachelor's degree in any discipline can apply. While healthcare or life sciences backgrounds are helpful, they are not mandatory."
            },
            {
                "id": 6,
                "Question": "What skills will I gain from this programme?",
                "Answer": "You will develop skills in strategic management, healthcare operations, financial decision-making, leadership, data analysis, and regulatory compliance, preparing you for senior roles in the industry."
            },
            {
                "id": 7,
                "Question": "Is this course UGC recognised?",
                "Answer": "Yes."
            },
            {
                "id": 8,
                "Question": "Can you enroll in this degree with a scholarship?",
                "Answer": "Yes. MSU is the only university in Sikkim to ensure 100% of student applicants receive government scholarships. Talk to our counselors to know more."
            },
            {
                "id": 9,
                "Question": "What is the admission procedure?",
                "Answer": "Call +91 98748 75876 for a detailed admission procedure. You can also refer to the link https://www.msu.edu.in/admission-process"
            }
        ]
    },

    programmeOverviewImage: {
        src: "https://cdn.msu.edu.in/MLT_Program_overview_2_01701b7fc7.jpg",
        alt: "Programme Overview"
    }
    , coursePrice: { price: "₹5,00,000" }

};